import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler } from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon } from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"

export default React.createClass({
  displayName: "age-check-guide",
  scrollToGuide: null,
  scrollingEl: null,
  getInitialState: function () {
    var data = [{ name: "Age Check Guide" }
    ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      android_release_version: "",
      android_release_date: "",
      ios_release_version: "",
      ios_release_date: "",
      server_java_release_version: "",
      server_java_release_date: "",
      server_c_release_version: "",
      server_c_release_date: "",
      zoom_web_release_version: "",
      zoom_web_release_date: "",
      scrollToElement: scrollToElement,
      isMobile: false
    };
  },

  componentDidMount: function () {
    mountCode(this);
    this.setState({isMobile: window.innerWidth <= 760});
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function () {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="age-check-guide">Age Check Guide</h2>
                </div>
                <p>FaceTec's Age Check achieves better-than-human performance and accuracy far better than other 2D Age Checks due to the rich data provided in the 3D FaceMap.  Learn more below!</p>
                <hr/>
              </section>

              <section>
                <div className="row">
                  <div className={this.state.isMobile == true? "col-xs-12" : "col-xs-7"}>
                    <h3 id="age-check-fundamentals" className="inside-section">Age Check Fundamentals</h3>
                    <ul>
                      <li><p>Age Check accuracy calculated from 3D FaceMaps.</p></li>
                      <li><p>Age Check for 2D Images is supported, but accuracy varies depending on 2D image quality.</p></li>
                    </ul>
                    <hr />


                    <h3 id="introduction-and-anonymity" className="inside-section">Introduction and Anonymity</h3>
                    <p>Because the 3D FaceMap is all that is needed for the Age Check, the process can be completely anonymous, or the Age Check can be used to corroborate the Date of Birth shown on a Photo ID. FaceTec is committed to continuous improvement to age checking practices -- our algorithms will continue to improve over time.</p>
                    <p>FaceTec's Age Check is much more accurate then 2D Age Checks because of the rich data in the 3D FaceMap.</p>

                    <hr />

                    <h3 id="get-started-with-age-check" className="inside-section">Get Started with Age Check</h3>
                    <p>Age Estimation is performed with every Liveness Check, Enrollment, Authentication, and Photo ID Match. Perform a session and check the <Link to="/server-dashboard-demo">FaceTec Server Dashboard</Link> for results.</p>

                    <hr />

                    <h3 id="age-estimation" className="inside-section">"Better than Human" Age Estimation</h3>
                    <p>It's important to note that Age Estimation is not easy for AI, but it's even harder for humans.  A 2013 study* at Michigan State crowd-sourced ~33,000 age estimations across two well-known public face databases and found human accuracy to be (depending on the database):</p>
                    <ul>
                      <li><p>Humans were only ~50-70% Accurate within 10 year range.</p></li>
                      <li><p>Humans were only ~77-~90% Accurate within 20 year range.</p></li>
                    </ul>
                    <p className="small">* <a href="http://biometrics.cse.msu.edu/Publications/Face/HanOttoJain_AgeEstimationFaceImages_HumanvsMachinePerformance_ICB13.pdf">Source Research</a></p>
                  </div>

                  <div className={this.state.isMobile == true? "col-xs-12" :"col-xs-5 splitSectionBorder"}>
                    <br/>
                    <h3 id="age-check-target-groups" className="inside-section">Age Check Target Groups</h3>
                    <p>FaceTec SDKs return an enum result that indicates the confidence at which the input FaceMap belongs to the target age group.  The age target groups and accuracies are:</p>

                    <ul>
                      <li><p>13 And Over - ~95% Accurate on people under 13. Accuracy on people 13 or over will vary with age range.</p></li>
                      <li><p>16 And Over - ~95% Accurate on people under 16. Accuracy on people 16 or over will vary with age range.</p></li>
                      <li><p>18 And Over - ~95% Accurate on people under 18. Accuracy on people 18 or over will vary with age range.</p></li>
                      <li><p>21 And Over - ~95% Accurate on people under 21. Accuracy on people 21 or over will vary with age range.</p></li>
                      <li><p>25 And Over - ~95% Accurate on people under 25. Accuracy on people 25 or over will vary with age range.</p></li>
                    </ul>

                    <p className="small">* Accuracies reported above are for FaceTec 3D FaceMaps.  Accuracy on 2D Images will vary based on image quality.</p>
                  </div>
                </div>
                <hr />
              </section>


              <section>
                <h3 id="age-check-technical-guide">Age Check - Technical Guide</h3>
                <p>FaceTec supports Age Check on both 3D FaceMaps and 2D Photos.</p>


                <h4 id="age-check-3d">Age Check on 3D FaceMaps</h4>
                <p>Steps:</p>
                <ol>
                  <li><p>Call prepareAndUpdateFaceMap on both FaceTec 3D FaceMaps.</p></li>
                  <li><p>Call /age-check (ageCheck in the FaceTec Server SDK) with the prepared FaceMap and target age group.</p></li>
                  <li><p>For instance, if the passed target age group is 2, this indicates a target age group of 18 or over.  For more information about age groups, please see the javadocs and header files for FaceTec Server, or the <Link to="/webservice-guide?link=Check%20Age" target="_blank">Age Check section of the REST API Guide</Link>.</p></li>
                  <li><p>Read the returned enum value.</p></li>
                  <li><p>A returned enum value of 0 indicates that there is high confidence that the FaceMap belongs to the target age group provided.  A returned enum value of 1 only indicates that there was not enough confidence to say that the FaceMap belongs to the target age group.  A result of 1 should not be used as confidence that the FaceMap is not in the target age group.</p></li>
                </ol>

                <h4 id="age-check-2d">Age Check on 2D Images</h4>
                <p>Steps:</p>
                <ol>
                  <li><p>Call createFaceMapFromImage on your 2D Image.</p></li>
                  <li><p>Call /age-check (ageCheck in the FaceTec Server SDK) with your 2D FaceMap and target age group.</p></li>
                  <li><p>Read the returned enum value.</p></li>
                  <li><p>Read ZoomFaceMapMetrics.faceMapIsLowQuality for an estimate of how reliable your result is based on the quality of the 2D Image/FaceMap.</p></li>
                </ol>
              </section>

              <SDKSidebar menuType="main" title="Matching Guide" />

            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/age-check-guide.jsx